import React from 'react'
import { WithTemplate } from '@morningtrain/react-app'
import { Link } from '@morningtrain/react-navigation'
import ReadLayout from 'layouts/crud/ReadLayout'
import * as Displays from 'support/displays'
import * as Columns from 'support/columns'
import { Prefix, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from '@morningtrain/react-columns'
import Button from 'ui/buttons/Button'
import TableWithHeaderWrap from 'ui/tables/TableWithHeaderWrap'
import TableScrollContainer from 'ui/tables/TableScrollContainer'
import SVGIcon from 'ui/helpers/SVGIcon'
import Title from 'layouts/page/Title'
import Confetti from 'ui/animations/Confetti'
import CartWrapper from 'services/cart/CartWrapper'
import ContentWrapper from 'ui/layouts/ContentWrapper'
import WhenModelValuesNotEqual from 'support/conditionals/WhenModelValuesNotEqual'
import DomainInfoColumns from 'widgets/domains/DomainInfoColumns'
import DualRowColumn from 'ui/columns/DualRowColumn'
// import ParameterLink from "support/displays/ParameterLink";

const Receipt = () => (
  <WithTemplate>
    <ContentWrapper>
      <CartWrapper>
        <ReadLayout crud={{ resourceName: 'orders' }}>
          <div className='relative overflow-hidden rounded-lg bg-primary-500 mb-6 px-6 py-10 sm:mb-8 sm:px-10 sm:py-16'>
            <SVGIcon type='checkmark' color='#FFFFFF' className='w-12 h-12 mx-auto mb-6' />
            <div className='text-white text-2xl text-center'>Tak for dit køb</div>
            <Confetti />
          </div>

          <TableWithHeaderWrap>
            <div className='px-6 pt-10 pb-8'>
              <Title className='text-2xl' />
            </div>

            <TableScrollContainer>
              <ValueToCollection name='links'>
                <Table>
                  <Prefix name='domain'>
                    <DomainInfoColumns />
                  </Prefix>
                  <Columns.Column label='Action'>
                    <Link route='app.links.edit' parameters={{ link: 'model:id' }} label='Skriv artikel' />
                  </Columns.Column>
                </Table>
              </ValueToCollection>
            </TableScrollContainer>

            <div className='index-table-layout-footer border-t border-gray-200 px-6 py-8 sm:px-10'>
              <div className='sm:flex sm:justify-between'>
                <div className='mb-6 mr-2 flex items-center sm:mb-0'>
                  <div className='sm:text-lg'>
                    <Displays.Length name='links' /> stk.
                    <div className='sm:text-xs'>Antal links</div>
                  </div>
                </div>

                <Link route='app.links.index'>
                  <Button text='Gå til dine links' />
                </Link>
              </div>
            </div>

          </TableWithHeaderWrap>
        </ReadLayout>
      </CartWrapper>
    </ContentWrapper>
  </WithTemplate>
)

export default Receipt
